/*
 * Tripventura — shared Swiper bootstrapper.
 *
 * Replaces the per-section inline `new Splide(...).mount()` scripts that the
 * blog and article sliders used to ship. Every slider now declares its config
 * as JSON on its root element and this one deferred, browser-cached file mounts
 * them all.
 *
 * Markup contract:
 *   <div class="swiper" data-tv-swiper='{"slidesPerView":1, ...}'>
 *     <ul class="swiper-wrapper">
 *       <li class="swiper-slide">…</li>
 *     </ul>
 *   </div>
 *
 * Notes:
 *  - Swiper breakpoints are MIN-width; Splide's were MAX-width. Configs are
 *    therefore written mobile-first — the base options describe the smallest
 *    screen and each breakpoint widens from there.
 *  - `navigation` / `pagination` take CSS selector strings. Swiper's default
 *    `uniqueNavElements` narrows a selector that matches many elements down to
 *    the single match inside this slider, so per-card sliders can share one
 *    class name; sliders whose controls live OUTSIDE the root (the tabbed blogs
 *    section) must pass a document-unique selector instead.
 *  - Swiper stores its instance on `el.swiper`, which doubles as the mounted
 *    guard — re-running init() after a theme-editor reload never double-mounts.
 *
 * API:  window.TVSwiper.init(scopeEl | document)
 *       window.TVSwiper.mount(el)
 * Auto-initialises the whole document once on load.
 */
(function () {
  if (window.TVSwiper) return;

  /*
   * Swiper 8 defaults `preloadImages: true`, and its preload pass builds a
   * `new Image()` with the src/srcset of every <img> inside the slider the
   * moment it mounts. That bypasses `loading="lazy"` entirely — it would fetch
   * all eight cards of every blog slider, all five hidden tabs of the tabbed
   * section (display:none does not stop `new Image()`), and all three 2000w
   * hero slides on first paint. Off by default; a slider can still opt back in
   * through its own data-tv-swiper config.
   */
  var DEFAULTS = { preloadImages: false };

  function mount(el) {
    if (el.swiper) return el.swiper; // already mounted
    if (typeof window.Swiper !== 'function') return null;

    var options;
    try {
      options = JSON.parse(el.dataset.tvSwiper || '{}');
    } catch (err) {
      console.error('[tv-swiper] invalid data-tv-swiper JSON', el, err);
      return null;
    }

    return new window.Swiper(el, Object.assign({}, DEFAULTS, options));
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-tv-swiper]').forEach(mount);
  }

  window.TVSwiper = { init: init, mount: mount };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* The theme editor re-renders a section's HTML wholesale; mount what's new. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
